import { BarChart, ManageAccounts, PeopleAlt, Archive, Workspaces, ArrowForwardIos, Check, Apartment } from '@mui/icons-material';
import { Box, Grid } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import './adminconsole.css';
import { AdminConsoleCardItem, AdminConsoleCardItemProps } from './AdminConsoleCardItem';
import { AdminConsolePanel } from './AdminConsolePanel';
import { AdminConsoleSupport } from './AdminConsoleSupport';
import { KeyDrivePrimaryButton } from '../../../components/KeydriveComponents/Buttons/KeyDrivePrimaryButton';
import { KeyDriveCaption } from '../../../components/KeydriveComponents/Fonts/Captions/KeyDriveCaption';
import { KeyDriveDialog } from '../../../components/KeydriveComponents/Dialog/KeyDriveDialog';
import { useState } from 'react';
import { KeydriveTextfield } from '../../../components/KeydriveComponents/Textfield/KeydriveTextfield';
import { CreateOrganization } from '../../../services/OrganizationServices';
import { LoginType } from '../../../utils/constants/LoginTypeConstants';

export const AdminConsole = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { nameOrg } = useParams();

    const [opencancelSigntureRightNow, setCancelSigntureRightNow] = useState<boolean>(false);
    const [organizationName, setOrganizationName] = useState<string>("");

    const AdminConsoleCardItemList: AdminConsoleCardItemProps[] = [
        {
            iconTitle: BarChart,
            title: t("Sidebar.Dashboard"),
            description: t("AdminConsole.DashboardSubtitle"),
            seeMoreAction: () => navigate(`/${nameOrg}/adminConsole/dashboard`),
        },
        {
            iconTitle: ManageAccounts,
            title: t("AdminConsole.AccountAndSubscription"),
            description: t("AdminConsole.ManageYourAccountAndSubscriptionEnsuringFullControlOverImportantSettings"),
            seeMoreAction: () => navigate(`/${nameOrg}/adminConsole/accountAndSubscription`),
        },
        {
            iconTitle: PeopleAlt,
            title: t("AdminConsole.UsersAndGroups"),
            description: t("AdminConsole.EfficientlyLearnAboutUsersAndGroupsToFacilitateCollaborationAccessControlAndPermissions"),
            seeMoreAction: () => navigate(`/${nameOrg}/adminConsole/usersAndGroups`),
        },
        {
            iconTitle: Workspaces,
            title: "Workspaces",
            description: t("AdminConsole.CheckOutAndManageOrganizationsViewingDetailsLikeStorageAndSettings"),
            seeMoreAction: () => navigate(`/${nameOrg}/adminConsole/workspaces`),
        },
        {
            iconTitle: Archive,
            title: t("AdminConsole.Plans"),
            description: t("AdminConsole.BrowseTheAvailablePlansCompareFeaturesAndChooseTheBestOptionForYourNeeds"),
            seeMoreAction: () => navigate(`/${nameOrg}/adminConsole/plans`),
        },
        {
            iconTitle: Apartment,
            title: t("AdminConsole.Organization"),
            description: t("AdminConsole.OrganizationContent"),
            seeMoreAction: () => navigate(`/${nameOrg}/adminConsole/organizations`),
        },
    ]

    return (
        <div style={{
            height: "100%",
            backgroundColor: '#F7F8FA',
        }}>
            <Box sx={{
            padding: '15px 30px',
            display: 'flex',
            gap: '20px',
            backgroundColor: '#F7F8FA',
            
        }}>
            <Grid container columnSpacing="20px" rowSpacing="20px">
                <Grid item xs={12}>
                    <AdminConsolePanel />
                </Grid>
                {AdminConsoleCardItemList.map(cardItem => {
                    return (
                        <Grid item xs={6}>
                            <AdminConsoleCardItem
                                description={cardItem.description}
                                iconTitle={cardItem.iconTitle}
                                seeMoreAction={cardItem.seeMoreAction}
                                title={cardItem.title}
                            />
                        </Grid>
                    )
                })}
            </Grid>
            <AdminConsoleSupport />
        </Box>

        <KeyDriveDialog 
            keyDriveDialogButtons={{
                leftButtonMethod: () => { setCancelSigntureRightNow(false) },
                rightButtonMethod: () => {

                },
                rightButtonText: t("AccountAndSubscription.Confirm"),
                leftButtonText: t("AccountAndSubscription.Back")
            }}
            keyDriveDialogContent={{
                dialogContent: (
                    <>
                        <KeydriveTextfield 
                            onChange={e => setOrganizationName(e.target.value)}
                            value={organizationName}
                        />

                        <KeyDrivePrimaryButton 
                            endIcon={<ArrowForwardIos />}
                            width="250px"
                            TextComponent={KeyDriveCaption}
                            TextComponentProps={{
                                color: "#E8EFF3",
                                needBold: false,
                                needEllipses: false,
                                text: t("FreeTier.AccessPlans")
                            }}
                            needFullWidth={false}
                            backgroundColor="#F58601"
                            disabled={nameOrg == undefined}
                            onClick={()=> {
                                CreateOrganization({ loginType: LoginType.EmailPassword, internalName: organizationName, name: organizationName })
                                .then(data => console.log(data))
                                .catch(err => console.log(err.response.data))
                            }}
                        />
                    </>
                ),
                dialogIcon: <Check sx={{ color: "#313335", width: "44px", height: "44px" }}/>,
                dialogTitle: t("AccountAndSubscription.CancelSubscriptionRightNow"),
                handleTogglDialog: () => {},
                openDialog: opencancelSigntureRightNow
            }}
            dialogTitleCenter
        >
        </KeyDriveDialog>
        
        </div>
    )
}

